import { render, staticRenderFns } from "./AddImageBlockModal.vue?vue&type=template&id=55411624&lang=pug&"
import script from "./AddImageBlockModal.vue?vue&type=script&lang=js&"
export * from "./AddImageBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports